import { __module as clamp } from '../../../../../_virtual/clamp.js';

var hasRequiredClamp;

function requireClamp () {
	if (hasRequiredClamp) return clamp.exports;
	hasRequiredClamp = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = clamp;
		/**
		 * Clamp a value between a min and max value
		 * @ignore
		 * @param {number} value
		 * @param {number} min
		 * @param {number} max
		 * @return {number}
		 */
		function clamp(value, min, max) {
		  return Math.min(Math.max(value, min), max);
		}
		module.exports = exports["default"];
		
	} (clamp, clamp.exports));
	return clamp.exports;
}

export { requireClamp as __require };
